"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getItemsAtRange_1 = __importDefault(require("./getItemsAtRange"));
var getListForItem_1 = __importDefault(require("./getListForItem"));
/**
 * True if selection is inside a list (and can be unwrapped)
 */
var isSelectionInList = function (opts) { return function (value, type) {
    var items = getItemsAtRange_1.default(opts)(value);
    return (!items.isEmpty() &&
        // Check the type of the list if needed
        (!type || getListForItem_1.default(opts)(value, items.first()).get('type') === type));
}; };
exports.default = isSelectionInList;
//# sourceMappingURL=isSelectionInList.js.map